import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const RailWrap = styled.div`
  margin-top: 32px;
  position: relative;
`;

export const Manager = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: ${getToken('font-family-default')};
  font-size: 11px;
  color: ${homeColor.amber};
  border: 1px dashed rgba(245, 181, 68, 0.5);
  border-radius: 999px;
  padding: 6px 14px;
  background: rgba(245, 181, 68, 0.06);
  margin-bottom: 18px;

  ${screen.lg} {
    font-size: 12px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 0;
  }
`;

export const ManagerDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${homeColor.amber};
`;

export const Rail = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px 0;
  position: relative;

  ${screen.lg} {
    grid-template-columns: repeat(7, 1fr);
    gap: 0;
    padding-top: 46px;

    &::before {
      content: '';
      position: absolute;
      top: calc(46px + 7px);
      left: 3%;
      right: 3%;
      height: 1px;
      background: linear-gradient(
        90deg,
        transparent,
        ${homeColor.line2} 8%,
        ${homeColor.line2} 92%,
        transparent
      );
    }
  }
`;

export const Progress = styled.span`
  display: none;

  ${screen.lg} {
    display: block;
    position: absolute;
    top: calc(46px + 6.5px);
    left: 3%;
    height: 2px;
    background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
    z-index: 0;
    transition: width 0.5s ease;
    border-radius: 1px;
    width: ${(props) => props.$width}%;
  }
`;

export const Stage = styled.button`
  background: none;
  border: none;
  font: inherit;
  color: inherit;
  cursor: pointer;
  padding: 0 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  position: relative;
`;

export const StageNode = styled.span`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin: 0 auto;
  background: ${homeColor.bg};
  border: 2px solid
    ${(props) => (props.$facility ? homeColor.cyan : homeColor.green)};
  position: relative;
  z-index: 1;
  display: block;
  transition:
    transform 0.25s,
    background 0.25s,
    box-shadow 0.25s;

  ${(props) =>
    props.$active &&
    `
    background: ${props.$facility ? homeColor.cyan : homeColor.green};
    box-shadow: 0 0 14px ${props.$facility ? homeColor.cyan : homeColor.green};
    transform: scale(1.3);
  `}
`;

export const StageName = styled.span`
  font-family: ${getToken('font-family-default')};
  font-weight: 700;
  font-size: 12px;
  margin-top: 10px;
  line-height: 1.25;
  display: block;
  color: ${(props) => (props.$active ? homeColor.white : homeColor.muted)};

  ${screen.md} {
    font-size: 13px;
  }

  ${screen.lg} {
    font-size: 14px;
  }
`;

export const RailCaps = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-top: 26px;

  ${screen.lg} {
    grid-template-columns: repeat(7, 1fr);
    gap: 0;
  }
`;

export const RailCap = styled.a`
  position: relative;
  padding: 12px 14px 0;
  text-align: center;
  font-family: ${getToken('font-family-default')};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${homeColor.muted2};
  transition: color 0.2s;

  ${screen.lg} {
    font-size: 11px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 8%;
    right: 8%;
    height: 1px;
    background: ${homeColor.line2};
  }

  b {
    color: ${homeColor.white};
    font-weight: 600;
    display: inline-flex;
    vertical-align: middle;

    svg {
      display: block;
    }
  }

  &:hover {
    color: ${homeColor.muted};
  }
  &:hover b {
    color: ${homeColor.green};
  }

  .arw {
    color: ${homeColor.green};
  }

  ${screen.lg} {
    &.sg {
      grid-column: 1 / 5;
    }

    &.od {
      grid-column: 5 / 8;
    }
  }
`;

export const StagePanel = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-top: 34px;
  border: 1px solid ${homeColor.line};
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.03);
  padding: 24px 22px;
  min-height: 172px;
  align-items: center;

  ${screen.lg} {
    grid-template-columns: 1fr 0.95fr;
    gap: 34px;
    padding: 26px 30px;
  }
`;

export const StageName2 = styled.div`
  font-family: ${getToken('font-family-title')};
  font-size: 16px;
  font-weight: 700;
  color: ${homeColor.white};

  ${screen.lg} {
    font-size: 18px;
  }
`;

export const StageProductTag = styled.span`
  display: inline-block;
  margin: auto 6px;
`;

export const StageList = styled.ul`
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
`;

export const StageListItem = styled.li`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted};
  font-size: 14px;
  line-height: 1.55;
  padding: 4px 0 4px 20px;
  position: relative;

  ${screen.lg} {
    font-size: 15px;
  }

  &::before {
    content: '';
    position: absolute;
    left: 2px;
    top: 0.85em;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: rgba(20, 214, 77, 0.55);
  }
`;

export const StageCard = styled.div`
  border: 1px solid rgba(20, 214, 77, 0.32);
  border-radius: 12px;
  padding: 18px 20px;
  background: ${homeColor.surface2};
`;

export const StageCardStatus = styled.span`
  font-family: ${getToken('font-family-default')};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  display: inline-flex;
  padding: 3px 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  background: rgba(20, 214, 77, 0.14);
  color: ${homeColor.green};
`;

export const StageCardTitle = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  color: ${homeColor.white};

  ${screen.lg} {
    font-size: 16px;
  }
`;

export const StageCardMeta = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 12px;
  color: ${homeColor.muted2};
  margin-top: 8px;

  b {
    color: ${homeColor.cyan};
    font-weight: 600;
  }
`;

export const StageCardValue = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 13px;
  font-weight: 600;
  color: ${homeColor.green};
  margin-top: 10px;
`;
